import React from 'react';
import '../styles/stepperVertical.css';
import LaptopIcon from '@material-ui/icons/Laptop';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import FlagIcon from '@material-ui/icons/Flag';
import UnarchiveIcon from '@material-ui/icons/Unarchive'
import { formatChosenDate, getTime, capitalizarPalabras } from '../utils';
import { DeliveryTest } from './DeliveryTest'
import useWindowDimensions from '../views/Login'

const Step = (props) => {
  if (props.isVerti) {
    return (<div className={'Stepper_Vertical'}>
      <div >
        <span className={`Stepper__info_${props.color}`}>{props.icon}</span>
      </div>
      <div className="Stepper_Vertical_Labels">
        <div className="Stepper__label_Vertical">{props.title}</div>
        <div className="Stepper__label2_Vertical">{props.fecha}</div>
        <div className="Stepper__Pod">{props.pod}</div>
      </div>
    </div>)
  } else {
    return (<div className={'Stepper__step'}>
      <div >
        <span className={`Stepper__info_${props.color}`}>{props.icon}</span>
      </div>
      <div className="Stepper__label">{props.title}</div>
      <div className="Stepper__label2">{props.fecha}</div>
      <div className="Stepper__label2">{props.incidencia}</div>
      <div className="Stepper__Pod">{props.pod}</div>
      <div className="Stepper__panel">
        {props.children}
      </div>
    </div>)
  }

};

// Overlay
const Stepper = (props) => {
  if (props.isVertical) {
    return (<div className={'Stepper_Vertical_father'} >
      {props.children}
    </div>)
  } else {
    return (<div className={`Stepper ${props.isInline ? 'Stepper--inline' : ''}`}>
      {props.children}
    </div>)
  }
};

const DivIncidencia = (props) => {
  if (props.incidencia !== null) {
    return (
      <div style={{display:'flex'}}>
         <div style={{color:'#9D9D9C'}}>Motivo:</div>
         <div>{ `${' '} ${capitalizarPalabras(props.incidencia)}`}</div>
      </div>
    )
  } else {
     return(null)
  }
}

export const StepperVertical = (elem) => {
  const item = elem.item;
  const { width } = useWindowDimensions();
  let check = false;
  let check2 = false;
  let check3 = false;
  let colorIcon2 = 'gris';
  let colorIcon3 = 'gris';
  let colorIcon4 = 'gris';
  let estado = 'Entregado';
  let pod = false;

    if(item.urlImg !== null && item.urlImg !== undefined && (item.urlImg).length > 0){
      pod = true;
    }

  if (item.estado_orden.toUpperCase() === 'ENTREGA PARCIAL') {
    colorIcon4 = 'entregaP';
    check = true;
    check2 = true;
    check3 = true;
    colorIcon2 = 'verde';
    colorIcon3 = 'verde';
  } else if (item.estado_orden.toUpperCase() === 'DEVOLUCIÓN TOTAL' || item.estado_orden === 'RECHAZADO') {
    item.estado_orden = 'RECHAZADO'
    colorIcon4 = 'rechazado';
    check = true;
    check2 = true;
    check3 = true;
    colorIcon2 = 'verde';
    colorIcon3 = 'verde';
  } else if (item.estado_orden.toUpperCase() === 'REPROGRAMADO') {
    check = true;
    colorIcon2 = 'verde';
    colorIcon4 = 'reprogramado';
  } else if (item.estado_orden.toUpperCase() === 'CANCELADO') {
    colorIcon4 = 'cancelado';
  } else if (item.estado_orden.toUpperCase() === 'ENTREGADO' || item.estado_orden.toUpperCase() === 'TERMINADO' || item.estado_orden.toUpperCase() === 'ENTREGADO COMPLETO' || item.estado_viaje === 'TERMINADO') {
    colorIcon4 = 'verde';
    check = true;
    check2 = true;
    check3 = true;
    colorIcon2 = 'verde';
    colorIcon3 = 'verde';
  } else if (item.estado_viaje.toUpperCase() === 'EN EJECUCIÓN' && item.estado_orden.toUpperCase() !== 'PROGRAMADO') {
    if (item.store_arrive_real_time === null) {
      colorIcon2 = 'amarillo';
      check = true
    } else {
      check = true;
      check2 = true
      colorIcon3 = 'amarillo';
      colorIcon2 = 'verde';
    }
  } else if (item.estado_viaje.toUpperCase() === "TERMINADO") {
    colorIcon4 = 'verde'
  }

  if (item.estado_orden.toUpperCase() === 'ENTREGA PARCIAL' || item.estado_orden.toUpperCase() === 'REPROGRAMADO' || item.estado_orden.toUpperCase() === 'RECHAZADO' || item.estado_orden.toUpperCase() === 'CANCELADO') {
    estado = (item.estado_orden).charAt(0).toUpperCase() + ((item.estado_orden).slice(1)).toLowerCase();
  }

  if (width > 780) {
    return (
      <div>
        <Stepper>
          <Step icon={<LaptopIcon />} title="Programado" fecha={`${formatChosenDate(item.appointment_time_programado, 1)} ${(item.appointment_time_programado !== null) ? ',' : ''} ${getTime(item.appointment_time_programado)}`} color={'verde'}>
          </Step>
          <div className={(!check) ? 'line_horizontal' : 'line_horizontal_check'}></div>
          <Step icon={<LocalShippingIcon />} title="En ejecución" fecha={`${formatChosenDate(item.warehouse_depart_real_time, 0)} ${(item.warehouse_depart_real_time !== null) ? ',' : ''} ${getTime(item.warehouse_depart_real_time)}`} color={colorIcon2}>
          </Step>
          <div className={(!check2) ? 'line_horizontal' : 'line_horizontal_check'}></div>
          <Step icon={<FlagIcon />} title="¡Hemos llegado!" fecha={`${formatChosenDate(item.fin_unload_real_time, 0)} ${(item.fin_unload_real_time !== null) ? ',' : ''} ${getTime(item.fin_unload_real_time)}`} color={colorIcon3}>
          </Step>
          <div className={(!check3) ? 'line_horizontal' : 'line_horizontal_check'}></div>
          <Step icon={<UnarchiveIcon />} title={estado} fecha={`${formatChosenDate(item.fin_unload_real_time, 0)} ${(item.fin_unload_real_time !== null) ? ',' : ''}  ${getTime(item.fin_unload_real_time)}`} pod={pod && <DeliveryTest images ={item.urlImg}></DeliveryTest>} incidencia={<DivIncidencia incidencia={item.incidencia}/>} color={colorIcon4}>
          </Step>
        </Stepper>
      </div>)
  } else {
    return (
      <div>
        <Stepper isVertical>
          <Step icon={<LaptopIcon />} title="Programado" fecha={`${formatChosenDate(item.appointment_time_programado, 1)} ${(item.appointment_time_programado !== null) ? ',' : ''} ${getTime(item.appointment_time_programado)}`} color={'verde'} isVerti>
          </Step>
          <div className={(!check) ? 'line_vertical' : 'line_vertical_check'}></div>
          <Step icon={<LocalShippingIcon />} title="En ejecución" fecha={`${formatChosenDate(item.warehouse_depart_real_time, 0)} ${(item.warehouse_depart_real_time !== null) ? ',' : ''} ${getTime(item.warehouse_depart_real_time)}`} color={colorIcon2} isVerti>
          </Step>
          <div className={(!check2) ? 'line_vertical' : 'line_vertical_check'}></div>
          <Step icon={<FlagIcon />} title="¡Hemos llegado!" fecha={`${formatChosenDate(item.fin_unload_real_time, 0)} ${(item.fin_unload_real_time !== null) ? ',' : ''} ${getTime(item.fin_unload_real_time)}`} color={colorIcon3} isVerti>
          </Step>
          <div className={(!check3) ? 'line_vertical' : 'line_vertical_check'}></div>
          <Step icon={<UnarchiveIcon />} title={estado} fecha={`${formatChosenDate(item.fin_unload_real_time, 0)} ${(item.fin_unload_real_time !== null) ? ',' : ''} ${getTime(item.fin_unload_real_time)}`} pod={pod && <DeliveryTest images ={item.urlImg}></DeliveryTest>} incidencia={<DivIncidencia incidencia={item.incidencia}/>} color={colorIcon4} isVerti>
          </Step>
        </Stepper>
      </div>
    )
  }
};